import { useContext, useEffect, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import AlertDialog from "../AlertDialog/AlertDialog";
import { EDialogAction } from "../Enum/DialogActionEnum";
import SkillDialogBox from "./SkillDialogBox";
import { useTheme } from "../../Hooks/ThemeContext/ThemeContext";
import { Button, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { LoadingStateContext } from "../../Hooks/LoadingContext/LoadingContext";
import { OpenInNew, EditOutlined, DeleteOutline } from "@mui/icons-material";

const SkillTable = (props: { filter: any }) => {
  const theme = useTheme();
  const [skill, setSkill] = useState(null);
  const [skillList, setSkillList] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [alertDialogVisibility, setAlertDialogVisibility] = useState(false);
  const [dialogAction, setDialogAction] = useState(EDialogAction.view);
  const { changeLoading, isLoading } = useContext(LoadingStateContext);
  useEffect(() => {
    getSkillList();
  }, [page, props.filter, limit]);

  const getSkillList = async () => {
    changeLoading(true);
    try {
      const response = await axiosInstance.get(
        `/v1/skills?type=${theme.theme}&page=${page}&items_per_page=${limit}`,
        {
          params: props.filter,
        }
      );

      const data = response.data;
      setSkillList(data.result.data);

      setTotalItems(data.result.total);

    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false);
    }
  };

  const getSkillById = async (skill: number, action: EDialogAction) => {
    try {
      const response = await axiosInstance.get(`/v1/skills/${skill}`, {});

      const data = response.data;
      setSkill(data.result);

      if (action == EDialogAction.edit) {
        setEditDialogVisibility(true);
      } else if (action == EDialogAction.view) {
        setEditDialogVisibility(true);
      } else if (action == EDialogAction.delete) {
        setAlertDialogVisibility(true);
      }
      setDialogAction(action);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  function editDialogClose(action: EDialogAction) {
    setEditDialogVisibility(false);
    if (action == EDialogAction.edit) {
    } else if (action == EDialogAction.view) {
    } else if (action == EDialogAction.delete) {
    }
    getSkillList();
  }
  function alertDialogClose(action: EDialogAction) {
    setAlertDialogVisibility(false);
    getSkillList();
  }

  return (
    <>
      <SkillDialogBox
        open={editDialogVisibility}
        onClose={editDialogClose}
        data={skill}
        dialogAction={dialogAction}
      />
      <AlertDialog
        openAlert={alertDialogVisibility}
        onCloseAlert={alertDialogClose}
        data={skill}
        action="skill"
      />
      <section>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Skill</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading && <TableRow><TableCell colSpan={3} align="center"><CircularProgress /></TableCell></TableRow>}
              {!isLoading && skillList.map((data: any, key: number) => {
                return (
                  <TableRow key={data.id}>
                    <TableCell>{data.skill_name}</TableCell>
                    <TableCell>{data.description}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => {
                          getSkillById(data.id, EDialogAction.view);
                        }}
                      >
                        <OpenInNew/>
                      </Button>{" "}
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        onClick={() => {
                          getSkillById(data.id, EDialogAction.edit);
                        }}
                      >
                        <EditOutlined/>
                      </Button>{" "}
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={() => {
                          getSkillById(data.id, EDialogAction.delete);
                        }}
                      >
                        <DeleteOutline/>
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
              {!isLoading && skillList.length == 0 && <TableRow><TableCell colSpan={3} align="center">No data found</TableCell></TableRow>}
            </TableBody>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              count={totalItems}
              rowsPerPage={limit}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Table>

        </TableContainer>

      </section>
    </>
  );
};

export default SkillTable;
